// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  /** 開発環境 */
  production: false,

  /** エラーをサーバーに送信する */
  sendError: false,

  /** 認証を有効にする */
  auth: true,

  /** サービスライセンス制御を有効にする */
  serviceLicense: true,

  /** データライセンス制御を有効にする */
  dataLicense: true,

  /** エラー画面にスタックトレースを表示する */
  stackTrace: true,

  /** ブラウザーチェックを無効にする */
  doNotCheckBrowser: true,

  /** Googleドライブ連携用変数 */
  googleDriveAPI: {
    clientId: '269442428529-arpeli3keqh21ra295bim7c75sm4d1k3.apps.googleusercontent.com',
  },

  /** 受発注PF規約 */
  partsOrderAgreement: {
    path: 'https://sfc.blcloud.jp/support/public/clause',
    fileName: 'PF_TermofUse.pdf',
  },

  /** リサイクル規約 */
  recycleAgreement: {
    path: 'https://test-01.blcloud.jp/support/public/clause',
    fileName: 'RC_TermofUse.pdf',
  },

  /** 顔認証 */
  faceDetection: {
    tenantId: 'broadleaf2022',

    userId: 'broadleaf2022',

    password: 'p0630-2',

    basePath: 'https://trial.kpas-cloud.com',
  },
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts